import React from 'react';
import './services.css';
import {BrowserView, MobileView} from 'react-device-detect';
import Image1 from '../../Assets/Piercing Services/ear piercing.png';
import Image2 from '../../Assets/Piercing Services/baby piercing.png';
import Image3 from '../../Assets/Piercing Services/nose piercing.png';
import Image4 from '../../Assets/Piercing Services/belly piercing (2).png';
import Image5 from '../../Assets/Piercing Services/tongue piercing (2).png';
import Image6 from '../../Assets/Piercing Services/Dermal piercing.png';
import star from '../../Assets/starwhite.png';
import arrow from '../../Assets/arrow 2.png';
import { useNavigate } from 'react-router-dom';


const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function Services() {
      const navigate = useNavigate();
  
  return (
    <div className="services-container">
      <BrowserView>
      <div>
        <img src={require('../../Assets/services_banner.png')} alt="banner" className="banner-image" />
        <div className="centered-text">
          <h1>piercing is a silent poem <br />etched in the skin</h1>
        </div>
        <div  className="centered-star">
          <img src={star} alt="Star Bullet" />
        </div>
      </div>
      
      <div className="discover-section">
        <h2>Discover Our Piercing Service</h2>
      </div>
      <div className="services-icons-section">
      <div className='servicetext'>
          <p>Needle Piercings</p>
        </div>
        <div className="service-icon-item">
          <img src={require('../../Assets/icon1.png')} alt="Needle Piercings" />
        </div>
        <div className="divider"></div>

        <div className='servicetext'>
          <p>Shop Services</p>
        </div>
        <div className="service-icon-item">
          <img src={require('../../Assets/icon2.png')} alt="Shop Services" />
        </div>
        <div className="divider"></div>

        <div className="service-icon-item">
          <img src={require('../../Assets/icon3.png')} alt="Home Service" />
        </div>
        <div className='servicetext'>
          <p>Home Service</p>
        </div>
      </div>


      {/* 6-column layout of images */}

      <div className="image-gallery">
        <div className="image-card" onClick={() => navigate("/earlobepiercing")}>
          <img src={Image1} alt="Ear Lobe piercing" />
          <div className="image-text">
          <h3>Ear piercing 100-125 aed </h3>
          <p>A classic and popular piercing done on the lower part of the ear lobe.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => navigate("/babypiercing")}>
          <img src={Image2} alt="Baby Ear piercing" />
          <div className="image-text">
          <h3>Baby Ear piercing 150-200 aed </h3>
          <p>Safe and gentle ear piercing for babies, ensuring a quick and comfortable experience.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => navigate("/nosepiercing")}>
          <img src={Image3} alt="Nose Piercing" />
          <div className="image-text">
          <h3>Nose Piercing 150 aed </h3>
          <p>A timeless piercing that adds a touch of elegance to your nose.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => navigate("/bellypiercing")}>
          <img src={Image4} alt="Belly Piercing" />
          <div className="image-text">
          <h3>Belly Piercing 200-250 aed</h3>
          <p>A sexy and bold belly button piercing for a standout look.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => navigate("/tonguepiercing")}>
          <img src={Image5} alt="Tongue Piercing" />
          <div className="image-text">
          <h3>Tongue Piercing 200 aed</h3>
          <p>A bold piercing for those who want to express their individuality.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => navigate("/chestdermalpiercing")}>
          <img src={Image6} alt="Chest Dermal Piercing" />
          <div className="image-text">
            <h3>Dermal Piercing 450 AED</h3>
            <p>A stunning surface piercing on the chest, offering a unique way to adorn the skin.</p>
          </div>
        </div>
      </div>

      <div className="view-all-services">
        <a href="/allservices">View All Services         <img src={arrow} alt="Arrow" className="arrow-image" />
        </a>
      </div>
      <br/>
      </BrowserView>
      <MobileView>

      <div style={{ position: 'relative' }}>
        <img src={require('../../Assets/services_banner_mob.png')} alt="banner" className="banner-image" />
        <div className="centered-text">
          <h5>piercing is a silent poem <br /> etched in the skin</h5>
        </div>
      </div>

      <div className="discover-section">
        <h2>Discover Our Piercing Service</h2>
      </div>
      <div >
      <div className="service-icon-item">
          <img src={require('../../Assets/icon1.png')} alt="Needle Piercings" />
        </div>
      <div className='servicetext'>
          <p>Needle Piercings</p>
        </div>


        <div className="service-icon-item">
          <img src={require('../../Assets/icon2.png')} alt="Shop Services" />
        </div>
        <div className='servicetext'>
          <p>Shop Services</p>
        </div>



        <div className="service-icon-item">
          <img src={require('../../Assets/icon3.png')} alt="Home Service" />
        </div>
        <div className='servicetext'>
          <p>Home Service</p>
        </div>
      </div>


      <div>
      <div className="image-card" onClick={() => handleWhatsAppClick("I am interested in Ear Lobe piercing")}>
          <img src={Image1} alt="Ear Lobe piercing" />
          <div className="image-text">
            <h3>Ear piercing 100-125 aed </h3>
            <p>A classic and popular piercing done on the lower part of the ear lobe.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => handleWhatsAppClick("I am interested in Baby Ear piercing")}>
          <img src={Image2} alt="Baby Ear piercing" />
          <div className="image-text">
          <h3>Baby Ear piercing 150-200 aed </h3>
          <p>Safe and gentle ear piercing for babies, ensuring a quick and comfortable experience.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => handleWhatsAppClick("I am interested in Nose Piercing")}>
          <img src={Image3} alt="Nose Piercing" />
          <div className="image-text">
          <h3>Nose Piercing 150 aed </h3>
          <p>A timeless piercing that adds a touch of elegance to your nose.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => handleWhatsAppClick("I am interested in Belly Piercing")}>
          <img src={Image4} alt="Belly Piercing" />
          <div className="image-text">
          <h3>Belly Piercing 200-250 aed</h3>
          <p>A sexy and bold belly button piercing for a standout look.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => handleWhatsAppClick("I am interested in Tongue Piercing")}>
          <img src={Image5} alt="Tongue Piercing" />
          <div className="image-text">
          <h3>Tongue Piercing 200 aed</h3>
          <p>A bold piercing for those who want to express their individuality.</p>
          </div>
        </div>

        <div className="image-card" onClick={() => handleWhatsAppClick("I am interested in Chest Dermal Piercing")}>
          <img src={Image6} alt="Chest Dermal Piercing" />
          <div className="image-text">
            <h3>Dermal Piercing 450 AED</h3>
            <p>A stunning surface piercing on the chest, offering a unique way to adorn the skin.</p>
          </div>
        </div>
      </div>



      <div className="view-all-services">
        <a href="/allservices">View All Services         <img src={arrow} alt="Arrow" className="arrow-image" />
        </a>
      </div>
      <br/>
      </MobileView>
    </div>
  );
}

export default Services;
